import React from 'react';
import { FaPhoneAlt } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { formatPhoneNumber } from '../../utils/formatter';
import ContainerHeader from '../shared/container/ContainerHeader';
import ContainerTitle from '../shared/container/ContainerTitle';

const VehicleClient = () => {
  const vehicle = useSelector((state) => state.vehicle.vehicle);
  return (
    <ContainerHeader>
      <ContainerTitle
        title={
          <div className="grid">
            <div className="flex text-xs sm:text-sm md:text-base">
              {vehicle.client.lastName} {vehicle.client.firstName}
            </div>
            <div className="text-xs sm:text-sm font-sans">Клієнт</div>
          </div>
        }
      />
      <div className="flex items-center gap-2 text-xs sm:text-sm md:text-base">
        <FaPhoneAlt size="12" />
        {formatPhoneNumber(vehicle.client.phone)}
      </div>
    </ContainerHeader>
  );
};

export default VehicleClient;
